import React, { useEffect, useState } from "react";
import { apiAxios } from "../../../../utils/apiAxios";
interface Person {
  name: string;
  rating: number;
  totalCases: number;
  avgMinutes: number;
}

interface Tier {
  tier: string;
  icon: string;
  theme: "gold" | "silver" | "bronze";
  designer: Person[];
  milling: Person[];
}



function initials(name: string) {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

function average(people: Person[]) {
  if (!people.length) return 0;
  return people.reduce((sum, p) => sum + p.rating, 0) / people.length;
}

function PersonRow({ person, rank }: { person: Person; rank: number }) {
  return (
    <li className={`ra-item ${rank === 1 ? "ra-item-top" : ""}`}>
      <span className="ra-rank">{rank}</span>
      <span className="ra-avatar">{initials(person.name)}</span>
      <div className="ra-name">
  <div>{person.name}</div>

  <small className="text-muted">
    Cases: {person.totalCases}
  </small>

  <br />

  <small className="text-muted">
    Avg Time: {person.avgMinutes} min
  </small>
</div>
     <span className="ra-rating">
  {Array.from({ length: person.rating }).map((_, index) => (
    <i
      key={index}
      className="bi bi-star-fill text-warning"
    />
  ))}
</span>
    </li>
  );
}

function RankedList({ people }: { people: Person[] }) {
  const sorted = [...people].sort((a, b) => b.rating - a.rating);

  return (
    <ul className="ra-list">
      {sorted.map((p, i) => (
        <PersonRow key={p.name} person={p} rank={i + 1} />
      ))}
    </ul>
  );
}

function TierCard({ tier }: { tier: Tier }) {
const overall = average([
  ...tier.designer,
  ...tier.milling,
]);
  return (
    <div className="col-lg-4 col-md-6">
      <div className={`ra-card ra-theme-${tier.theme}`}>
        <div className="ra-card-header">
          <span className="ra-header-badge">
            <i className={`bi ${tier.icon}`} />
          </span>
          <div className="ra-header-text">
            <h5 className="ra-header-title">{tier.tier}</h5>
            <span className="ra-header-sub">
             {tier.designer.length +
 tier.milling.length} providers
            </span>
          </div>
          <span className="ra-header-score">
            <i className="bi bi-star-fill" /> {overall.toFixed(1)}
          </span>
        </div>
<div className="ra-card-body">

  {/* Designer */}
  <div className="ra-section">
    <div className="ra-section-title">
      <i className="bi bi-person-badge" /> Designer
      <span className="ra-count">{tier.designer.length}</span>
    </div>
    <RankedList people={tier.designer} />
  </div>

  <div className="ra-divider" />

 


  {/* Milling */}
  <div className="ra-section">
    <div className="ra-section-title">
      <i className="bi bi-gear-wide-connected" /> Milling
      <span className="ra-count">{tier.milling.length}</span>
    </div>
    <RankedList people={tier.milling} />
  </div>

</div>
      </div>
    </div>
  );
}
interface SelfEvaluationDto {
  userId: number;
  roleType: string;
  name: string;
  totalCases: number;
  avgMinutes: number;
  avgTime: number;
  starRating: number;
  ratingText: string;
}
function InternalPerformanceRating() {

  const [tierData, setTierData] = useState<Tier[]>([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
  getSelfEvaluation();
}, []);

const getSelfEvaluation = async () => {
  try {
    setLoading(true);

    const response = await apiAxios.get("/Central/self-evaluation");

    console.log("Self Evaluation Response:", response.data);

    if (response.data.isSuccess) {
      const data = response.data.singleData || [];

      console.log("Self Evaluation Data:", data);

      buildTierData(data);
    } else {
      toast.error(response.data.message || "Unable to fetch self evaluation.");
    }
  } catch (error) {
    console.error("Error fetching self evaluation:", error);
    toast.error("Unable to fetch self evaluation.");
  } finally {
    setLoading(false);
  }
};

const buildTierData = (data: SelfEvaluationDto[]) => {

  const getTheme = (rating: string): "gold" | "silver" | "bronze" => {
    switch (rating.toLowerCase()) {
      case "excellent":
        return "gold";
      case "very good":
        return "silver";
      default:
        return "bronze";
    }
  };

  const grouped = [...new Set(data.map(x => x.ratingText))].map(rating => ({

    tier: rating,

    icon:
      rating === "Excellent"
        ? "bi-trophy-fill"
        : rating === "Very Good"
        ? "bi-award-fill"
        : "bi-shield-fill",

    theme: getTheme(rating),

    designer: data
      .filter(
        x =>
          x.ratingText === rating &&
          x.roleType === "DESIGNER"
      )
      .map(x => ({
        name: x.name,
        rating: x.starRating,
        totalCases: x.totalCases,
        avgMinutes: x.avgMinutes
      })),

    milling: data
      .filter(
        x =>
          x.ratingText === rating &&
          (x.roleType === "MILLING" ||
           x.roleType === "MILLING HUB")
      )
      .map(x => ({
        name: x.name,
        rating: x.starRating,
        totalCases: x.totalCases,
        avgMinutes: x.avgMinutes
      }))
  }));

  setTierData(grouped);
};
if (loading) {
  return <div className="text-center mt-5">Loading...</div>;
}
  return (
    <div className="container-fluid mt-4">
      <div className="ra-page-header">
        <div>
          <h4 className="mb-2">Internal Performance Rating</h4>
          <p className="text-muted mb-0">
            Top rated designers and milling hubs, ranked by tier
          </p>
        </div>
      </div>

    <div className="row g-4">
  {tierData.length > 0 ? (
    tierData.map((tier) => (
      <TierCard key={tier.tier} tier={tier} />
    ))
  ) : (
    <div className="col-12 text-center">
      No performance data available.
    </div>
  )}
</div>
    </div>
  );
}

export default InternalPerformanceRating;
